const progressBarWrapper: React.CSSProperties = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
};

const progressBarContainer: React.CSSProperties = {
  width: '100%',
  backgroundColor: '#e0e0e0' /* Couleur de fond */,
  borderRadius: '25px' /* Coins arrondis */,
  overflow: 'hidden',
  position: 'relative',
};

const progressBar: React.CSSProperties = {
  height: '20px' /* Hauteur de la barre */,
  borderRadius: '25px 25px 25px 25px' /* Coins arrondis à gauche */,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'width 0.3s ease' /* Animation de la largeur */,
};

const progressText: React.CSSProperties = {
  color: 'white' /* Couleur du texte */,
  fontWeight: 'bold',
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  fontSize: window.innerWidth <= 500 ? '9px' : '12px',
  textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
  whiteSpace: 'nowrap',
  padding: '0 4px',
  zIndex: 1,
};

const progressLabelBelow: React.CSSProperties = {
  marginTop: '4px',
  fontSize: window.innerWidth <= 500 ? '10px' : '12px',
  color: '#444444',
  fontWeight: 500,
  textAlign: 'center',
  lineHeight: '1.3',
};

const style = {
  progressBarWrapper,
  progressBarContainer,
  progressBar,
  progressText,
  progressLabelBelow,
};

export default style;
